import { BENEFITS_ID } from "../../../../constant";
import Content01 from "./components/content-benefits-01";
import Content02 from "./components/content-benefits-02";
import Content03 from "./components/content-benefits-03";

const BenefitsPage = () => {
    return (
        <div id={BENEFITS_ID} className="flex flex-col bg-[#031602]" style={{ fontFamily: 'Lexend Deca, sans-serif' }}>
            <div className="mb-20 pb-20 grid grid-cols-5 bg-[#0F1E0E] lg:mr-10 xl:mr-16 2xl:mr-24">
                <Content01 />
                <div className="hidden col-span-2 lg:block">
                    <img src="/media/images/landing-page/Benefits-01.png" alt="Benefits-01" className="w-full pt-40 xl:pr-32 2xl:pr-32" />
                </div>
            </div>
            <div className="mb-20 pb-20 grid grid-cols-5 bg-[#0F1E0E] lg:ml-10 xl:ml-16 2xl:ml-24">
                <div className="hidden w-full col-span-2 lg:block">
                    <img src="/media/images/landing-page/Benefits-02.png" alt="Benefits-02" className="w-full ml-8 lg:pt-20 xl:ml-20 2xl:ml-12" />
                </div>
                <Content02 />
            </div>
            <div className="mb-20 pb-20 grid grid-cols-5 bg-[#0F1E0E] lg:mr-10 xl:mr-16 2xl:mr-24">
                <Content03 />
                <div className="hidden col-span-2 lg:block">
                    <img src="/media/images/landing-page/Benefits-03.png" alt="Benefits-03" className="w-full pt-20 pr-20 lg:pr-0 lg:pt-40 xl:ml-8 xl:pr-32 2xl:pr-20" />
                </div>
            </div>
        </div>
    )
}

export default BenefitsPage;
